<div *ngIf="project" class="project-card" [class.featured]="featured">
  <uni-json-ld-schema [itemLD]="projectSchema"></uni-json-ld-schema>
  <uni-project-card-header
    *ngIf="showUsers"
    [project]="project"
    [self]="self"
    [showContextMenu]="true"
    (removedProject)="removeProject($event)">
  </uni-project-card-header>
  <div class="rounded-border hover-shadow-4">
    <uni-project-card-image
      [project]="project"
      [featured]="featured"
      [self]="self"
      [host]="host"
      [showTrophyBadge]="true"
      [showGeneralBadges]="true"
      [dialogOpenable]="dialogOpenable"
      (openDialogEvent)="openProjectDialog()">
    </uni-project-card-image>
    <uni-project-card-title
      [project]="project"
      [self]="self"
      [host]="host"
      [dialogOpenable]="dialogOpenable"
      (openDialogEvent)="openProjectDialog()">
    </uni-project-card-title>
    <ng-container *ngIf="featured">
      <uni-project-card-subtitle
        [project]="project">
      </uni-project-card-subtitle>
    </ng-container>
    <uni-project-card-footer
      [featured]="featured"
      [project]="project"
      [host]="host"
      [self]="self">
    </uni-project-card-footer>
  </div>
</div>
